import axios from 'axios';
import MainURL from '../../../MainURL';

export interface PraiseRecommendSong {
  id: number;
  title: string;
  stateSort: string;
  keySort: string;
  tempoSort: string;
  theme: string;
}

// getsongssearchtheme은 theme 배열을 AND로 묶어서 검색하므로(한 곡이 모든 주제를
// 동시에 가지고 있어야 매칭됨), 주제마다 개별 검색해서 결과를 합친다(OR 방식).
export async function fetchSongsByThemes(themes: string[]): Promise<PraiseRecommendSong[]> {
  if (themes.length === 0) return [];

  const songsResults = await Promise.all(
    themes.map((theme) =>
      axios.post(`${MainURL}/worshipsongs/getsongssearchtheme`, { theme: [theme] })
    )
  );

  const songsById = new Map<number, PraiseRecommendSong>();
  songsResults.forEach((songsRes) => {
    const themeSongs: PraiseRecommendSong[] = songsRes.data?.resultData || [];
    themeSongs.forEach((song) => {
      if (!songsById.has(song.id)) songsById.set(song.id, song);
    });
  });

  return Array.from(songsById.values());
}
